import {Heading, Image, Link, River, Text, Stack} from '@primer/react-brand'
import type {RiverProps} from '@primer/react-brand'

import {getImageSources} from '@github-ui/swp-core/lib/utils/images'

import {AssetTypeEnum} from '../types'
import type {LabelAssetLinkItem} from '../types'
import {AssetVideo} from './Video'
import {renderWithNoMarks} from '../utils'

export type FeaturedStackProps = {
  items?: LabelAssetLinkItem[]
  alignment?: 'alternate' | 'start' | 'end'
  variant?: RiverProps['variant']
}

const RIVER_ALIGNMENTS: Array<RiverProps['align']> = ['start', 'end']

export const FlexSuiteRiverStack = ({items, alignment = 'start', variant = 'gridline'}: FeaturedStackProps) => {
  if (!items || items.length === 0) return null

  return (
    <Stack direction="vertical" padding="none" gap="spacious">
      {items.map((item, index) => {
        const {
          heading,
          description,
          href,
          label,
          alt,
          assetType,
          optionImage,
          optionVideo,
          optionPoster,
          autoplay,
          videoSource,
        } = item.fields

        const align: RiverProps['align'] =
          alignment === 'alternate' ? RIVER_ALIGNMENTS[index % RIVER_ALIGNMENTS.length] : alignment

        return (
          <River key={item.sys.id} align={align} variant={variant}>
            <River.Visual>
              {assetType === AssetTypeEnum.enum.Image && optionImage && (
                <Image
                  as="picture"
                  src={`${optionImage.fields.file.url}?fm=webp`}
                  sources={getImageSources(optionImage.fields.file.url, {maxWidth: 720})}
                  alt={optionImage.fields.description ?? ''}
                />
              )}
              <AssetVideo
                assetType={assetType}
                optionVideo={optionVideo}
                optionPoster={optionPoster}
                autoplay={autoplay}
                videoSource={videoSource}
              />
            </River.Visual>
            <River.Content>
              <Heading as="h3" size="5">
                {renderWithNoMarks(heading)}
              </Heading>
              <Text>{renderWithNoMarks(description)}</Text>
              <Link href={href} {...(alt ? {'aria-label': alt} : {})}>
                {label}
              </Link>
            </River.Content>
          </River>
        )
      })}
    </Stack>
  )
}
